// extracted by mini-css-extract-plugin
export var label = "_r3-0";
export var link = "_r3-1";